'use client';

import { useState } from 'react';
import dynamic from 'next/dynamic';
import AuthDrawerSkeleton from '../auth-drawer-skeleton';
import type { ResetPasswordDrawerProps } from './types';

export { RESET_PASSWORD_DRAWER_ID } from './constants';

// EWM-306: lazy-load the drawer body so it stays out of the critical bundle
// until the user first opens an auth drawer.
const ResetPasswordDrawerContent = dynamic(() => import('./components/reset-password-drawer-content'), {
  ssr: false,
  loading: () => <AuthDrawerSkeleton headlineKey="auth.reset-password-title" />,
});

const ResetPasswordDrawer = (props: ResetPasswordDrawerProps) => {
  // Latch: the provider always renders this drawer (toggling isOpen), so a naive
  // dynamic() would fetch the chunk on page load. Render nothing until the first
  // open; once opened, stay mounted so the close animation plays and re-opens
  // need no second fetch.
  const [hasOpened, setHasOpened] = useState(false);
  if (props.isOpen && !hasOpened) setHasOpened(true);
  if (!hasOpened) return null;

  return <ResetPasswordDrawerContent {...props} />;
};

export default ResetPasswordDrawer;
